module.exports = __webpack_public_path__ + "media/v2/components/Contests/shared/Players/Player/Modal/img/close-ede18d29f4eb302f797d92bea5557f11.svg";